import { Component, OnInit, Input } from '@angular/core';
import { isTrue, formatInput } from '../form-controls.util';

@Component({
  selector: 'custom-input',
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.scss']
})
export class CustomInputComponent implements OnInit {
  /**
   * 
   */
  @Input()
  set readonly(v: boolean) {
    this.isReadonly = isTrue(v);
  }
  /**
   * 
   */
  @Input()
  set inline(v: boolean) {
    this.isInline = isTrue(v);
  }
  /**
   * 
   */
  @Input()
  label: string;
  /**
   * 
   */
  @Input()
  value: any;
  /**
   * 
   */
  @Input()
  set disabled(v: boolean) {
    this.isDisabled = isTrue(v);
  }
  /**
   * 
   */
  @Input()
  format: string;

  isInline = false;
  isDisabled = false;
  isReadonly = false;

  constructor() { }

  ngOnInit() {
  }

  getValue() {
    if (this.value && this.format) {
      return formatInput(this.value, this.format);
    }
    return this.value;
  }

}
